<template>
  <v-card :loading="mutationLoading">
    <v-row no-gutters>
      <v-img
        v-if="file.type == 'image'"
        :src="loadMedia(mediaPath + file.path + file.name, 'sm')"
        :lazy-src="loadMedia(mediaPath + file.path + file.name, 'thumbnail')"
        class="checkered-background"
      ></v-img>

      <video
        v-else-if="file.type == 'video'"
        class="d-block"
        width="100%"
        controls
      >
        <source :src="mediaPath + file.path + file.name" />
      </video>

      <v-icon v-else size="100" class="mt-1">mdi-file-document-outline</v-icon>
    </v-row>
    <v-card-text>
      <v-form>
        <v-row no-gutters>
          <v-col sm="12">
            <strong class="mr-2">Name:</strong>
            <span>{{ file.name }}</span>
          </v-col>
          <v-col sm="12">
            <strong class="mr-2">Type:</strong>
            <span>{{ file.type }}</span>
          </v-col>
          <v-col sm="12">
            <strong class="mr-2">Mime type:</strong>
            <span>{{ file.mimeType }}</span>
          </v-col>
          <v-col sm="12">
            <strong class="mr-2">Extension:</strong>
            <span>{{ file.extension }}</span>
          </v-col>
          <v-col sm="12">
            <strong class="mr-2">File size:</strong>
            <span>{{ file.size | prettyBytes }}</span>
          </v-col>
          <v-col sm="12">
            <v-row no-gutters class="mt-2">
              <v-spacer></v-spacer>
              <v-btn
                small
                color="success"
                class="mr-2"
                :href="`storage/media${file.path}${file.name}`"
                target="_blank"
                v-if="!isDialog"
                >Open</v-btn
              >
              <v-btn small color="error" @click="confirmDelete">delete</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
// import SecureFile from "@/components/global/SecureFile";
import { deleteMediaFile } from '@/graphql/media.gql'
import swal from 'sweetalert2'

export default {
  name: 'MediaFilePreview',
  props: {
    file: {
      type: Object,
      required: true
    },
    mediaPath: {
      type: String,
      required: true
    },
    isDialog: {
      type: Boolean
    }
  },
  components: {
    // SecureFile
  },
  data: () => ({
    mutationLoading: false
  }),
  methods: {
    confirmDelete() {
      swal({
        title: 'Are you sure?',
        text:
          'Deleting this file will affect all content where this file is attached to.',
        type: 'warning',
        showCancelButton: true,
        allowOutsideClick: false
      }).then(({ value }) => {
        if (value) {
          this.deleteFile()
        }
      })
    },
    deleteFile() {
      this.mutationLoading = true

      this.$apollo
        .mutate({
          mutation: deleteMediaFile,
          variables: {
            data: {
              path: this.file.path,
              name: this.file.name
            }
          }
        })
        .then(data => {
          let response = data.data.deleteMediaFile

          this.handleGraphQLSuccess(response.message)

          this.dialog = false

          this.$emit('deleted')

          this.mutationLoading = false
        })
        .catch(error => {
          this.handleGraphQLErrors(error)

          this.mutationLoading = false
        })
    }
  }
}
</script>
